import { getJobCategorySuids } from "@/jobCategorySuids";
import { getJobTypeSuids } from "@/jobTypeSuids";
import { SearchParamType } from "@/types/SearchParamType";
import { getCurrentPageNumber, getUpdatedSearchParams, } from "@/components/utils";
var getAdjacentPageCursor = function (pageCursors, offset) {
    var pageCursor = pageCursors.get(getCurrentPageNumber(pageCursors) + offset);
    return pageCursor == null || pageCursor == "" ? undefined : pageCursor;
};
export var getPrevPageCursor = function (pageCursors) {
    return getAdjacentPageCursor(pageCursors, -1);
};
export var getNextPageCursor = function (pageCursors) {
    return getAdjacentPageCursor(pageCursors, 1);
};
export var getPageParams = function (searchParams, pageCursor, fallbackCountry) {
    if (fallbackCountry === void 0) { fallbackCountry = ""; }
    var what = searchParams.get(SearchParamType.WHAT) || "";
    var where = searchParams.get(SearchParamType.WHERE) || "";
    var country = searchParams.get(SearchParamType.COUNTRY) || fallbackCountry;
    var company = searchParams.get(SearchParamType.COMPANY) || "";
    var isRemoteOnly = searchParams.get(SearchParamType.IS_REMOTE_ONLY) === "true";
    return getUpdatedSearchParams(searchParams, what, where, isRemoteOnly, pageCursor, country, company, getJobCategorySuids(searchParams), getJobTypeSuids(searchParams));
};
